import React, { useEffect, lazy, Suspense, useState } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  HostelGetAll,
  AnnouncementGetAll,
  ServicesGetAll,
  OtherServicesGetAll,
} from "./Redux/Feature/CommonSlice";
import { Box } from "@mui/system";
import ContactList from "./Pages/Admin/ContactUs/ContactList";
import ViewContact from "./Pages/Admin/ContactUs/ViewContact";
import { useTranslation } from "react-i18next";
import CancelIcon from '@mui/icons-material/Cancel';
import ChatIcon from '@mui/icons-material/Chat';

import Dashboard from "./Pages/User/Dashboard";

import Main from "./Pages/User/Main";
import NewsReview from "./Pages/User/News/NewsReview";
import NewsList from "./Pages/User/News/NewsList";
import Application from "./Pages/User/Application";
import Services from "./Pages/User/Services";
import Intro from "./Pages/User/Intro";
import Account from "./Pages/User/Account";
import ContactUs from "./Pages/User/Account/ContactUs";
import ChecklistItems from "./Pages/User/Account/CheckList/ChecklistItems";
import CheckoutForm from "./Pages/User/Account/CheckoutForm";
import BreakContact from "./Pages/User/Account/BreakContact.jsx";
import HostelReview from "./Pages/User/HostelReview";
import LandingPage from "./LandingPage";

import AdminDashboard from "./Pages/Admin/Dashboard";
import AnnouncementList from "./Pages/Admin/Announcement/AnnouncementList";
import AnnouncementAdd from "./Pages/Admin/Announcement/AnnouncementAdd";
import AdminNewsList from "./Pages/Admin/News/NewsList";
import AdminNewsAdd from "./Pages/Admin/News/NewsAdd";
import AdminHostelAdd from "./Pages/Admin/Hostel/HostelAdd";
import Hostellist from "./Pages/Admin/Hostel/Hostellist";
import AdminApplication from "./Pages/Admin/Application/ApplicationList";
import AdminServices from "./Pages/Admin/Services";
import ApplicationReview from "./Pages/Admin/Application/ApplicationReview";

import EditAnnouncement from "./Pages/Admin/Announcement/EditAnnouncement.jsx";
import NewsEdit from "./Pages/Admin/News/NewsEdit.jsx";
import EditHostel from "./Pages/Admin/Hostel/EditHostel.jsx";
import PageNotFound from "../src/LandingPage/PageNotFound";
import Contract from "./Pages/User/Application/Contract";
import AddServices from "./Pages/Admin/Services/AddServices";
import AddOtherService from "./Pages/Admin/Services/AddOtherService";
import EditOtherService from "./Pages/Admin/Services/EditOtherService";
import EditServices from "./Pages/Admin/Services/EditServices";
import CheckListMain from "./Pages/Admin/Checklist/CheckListMain";
import AddCheckList from "./Pages/Admin/Checklist/AddCheckList";
import EditCheckList from "./Pages/Admin/Checklist/EditCheckList";
import ChargesMain from "./Pages/Admin/Charges/ChargesMain";
import AddDeposits from "./Pages/Admin/Charges/AddDeposits";
import EditDeposits from "./Pages/Admin/Charges/EditDeposits";
import AddMainAmount from "./Pages/Admin/Charges/AddMainAmount";
import EditMainAmount from "./Pages/Admin/Charges/EditMainAmout";
import Queries from "./Pages/Admin/Query/Queries";
import ViewQueries from "./Pages/Admin/Query/ViewQueries";
import ContactUsMain from "./Components/ContactUsMain";
import AboutMain from "./Pages/Admin/AboutUs/AboutMain";
import ContactUsAdmin from "./Pages/Admin/ContactUsClient/ContactUsAdmin";
import CarouselMain from "./Pages/Admin/Carousel/CarouselMain";
import AddCarousel from "./Pages/Admin/Carousel/AddCarousel";
import EditCarousel from "./Pages/Admin/Carousel/EditCarousel";
import UserMain from "./Pages/Admin/User/UserMain";
import ViewUser from "./Pages/Admin/User/ViewUser";
import ViewTemporaryUser from "./Pages/Admin/User/ViewTemporaryUser";
import CommonServices from "./Pages/Admin/CommonServices";
import AddCommonService from "./Pages/Admin/CommonServices/AddCommonService";
import EditCommonService from "./Pages/Admin/CommonServices/EditCommonService";
import LandingService from "./Pages/User/ServiceApplications/LandingService";
import AcademyPathwayCounselling from "./Pages/User/ServiceApplications/AcademyPathwayCounselling";
import ChartedCarService from "./Pages/User/ServiceApplications/ChartedCarService";
import EnglishTrialClass from "./Pages/User/ServiceApplications/EnglishTrialClass";
import FestivalActivities from "./Pages/User/ServiceApplications/FestivalActivities";
import GuardianService from "./Pages/User/ServiceApplications/GuardianService";
import InternationalCompetition from "./Pages/User/ServiceApplications/InternationalCompetition";
import PickUpService from "./Pages/User/ServiceApplications/PickUpService";
import SubjectTuition from "./Pages/User/ServiceApplications/SubjectTuition";
import WeekendActivities from "./Pages/User/ServiceApplications/WeekendActivities";
import AdminPolicyNotice from "./Pages/Admin/PolicyNotice/AdminPolicyNotice.jsx";
import AdminTermsCondition from "./Pages/Admin/TermsAndCondition/AdminTermsCondition.jsx";
import PrivacyPolicy from "./Pages/User/Policy/PolicyNotice.jsx";
import TermsAndConditions from "./Pages/User/TermsAndCondition/TermsAndCondition.jsx";
import BookedServicesMain from "./Pages/Admin/BookedServices/BookedServicesMain";
import ViewBookedService from "./Pages/Admin/BookedServices/ViewBookedService";
import PrivateRoute from "./LandingPage/PrivateRoute";
import AdminLogin from './LandingPage/AdminLogin'
import AdminRoute from "./LandingPage/AdminRoute";
import NewsAdd from "./Pages/Admin/News/NewsAdd";
import DentalMain from "./Pages/Admin/Dental/DentalMain";
import DentalAdd from "./Pages/Admin/Dental/DentalAdd";
import DentalEdit from "./Pages/Admin/Dental/DentalEdit";
import ApplicationDental from "./Pages/User/DentalBooking/ApplicationDental";
import DentalMainPage from "./Pages/User/DentalBooking/DentalMainPage";
import DentalClinics from "./Pages/User/DentalBooking/DentalClinics";
import DentalLogin from "./LandingPage/DentalLogin";
import DentalDashboard from "./Pages/Dental/DentalDashboard";
import DentalRoute from "./LandingPage/DentalRoute";
import DentalApplications from "./Pages/Dental/DentalApplication/DentalApplications";
import DentalProfile from "./Pages/Dental/DentalApplication/DentalProfile";
import ForgotPasswordDental from "./LandingPage/ForgotPasswordDental";
import PublicRoute from "./LandingPage/PublicRoute";
import DentelContent from "./Pages/Admin/Dental/DentelContent";
import DentalBookings from "./Pages/Admin/Dental/DentalBookings";
import PaymentSuccess from "./Components/PaymentSuccess"
import PdfGenerate from "./PdfGenerate";
import Chatbot from "react-chatbot-kit";
import "react-chatbot-kit/build/main.css";
import Faq from './Pages/User/Faq'
import config from "./config";
import MessageParser from "./MessageParser";
import ActionProvider from "./ActionProvider";
import { IconButton } from "@mui/material";
import HelpCenter from "./Pages/User/HelpCenter";
import shareIcon from './assets/Links1.png'
import Social6 from './assets/Social6.png'
import Social9 from './assets/Social9.png'
import Social10 from './assets/Social10.png'
import Social8 from './assets/Social8.png'
import Social5 from './assets/Social5.png'
import Social4 from './assets/Social4.png'
import Social3 from './assets/Social3.png'
import Social1 from './assets/Social1.png'
import Link2 from './assets/Link.png'
import CheckListRequest from "./Pages/Admin/Checklist/CheckListRequest.jsx";
import ViewCheckListRequest from "./Pages/Admin/Checklist/ViewCheckListRequest.jsx";
import StudentReportList from "./Pages/Admin/StudentReport/StudentReportList.jsx";
import StudentReportAdd from "./Pages/Admin/StudentReport/StudentReportAdd.jsx";



// const ContactUs = lazy(() => import('./Pages/User/Account/ContactUs'))

// const Dashboard = lazy(() => import('./Pages/User/Dashboard'))
// const NewsList = lazy(() => import('./Pages/User/News/NewsList'))
// const Intro = lazy(() => import('./Pages/User/Intro'))
// const Application = lazy(() => import('./Pages/User/Application'))
// const Services = lazy(() => import('./Pages/User/Services'))
// const Main = lazy(() => import('./Pages/User/Main'))
// const ContactUsMain = lazy(() => import('./Components/ContactUsMain'))

// const Account = lazy(() => import('./Pages/User/Account'))
// const ContactUs = lazy(() => import('./Pages/User/Account/ContactUs'))
// const ChecklistItems = lazy(() => import('./Pages/User/Account/CheckList/ChecklistItems'))
// const CheckoutForm = lazy(() => import('./Pages/User/Account/CheckoutForm'))
// const BreakContact = lazy(() => import('./Pages/User/Account/BreakContact.jsx'))
// const HostelReview = lazy(() => import('./Pages/User/HostelReview'))
// const LandingPage = lazy(() => import('./LandingPage'))

// const NewsReview = lazy(() => import('./Pages/User/News/NewsReview'))

// const AdminDashboard = lazy(() => import('./Pages/Admin/Dashboard'))
// const AnnouncementList = lazy(() => import('./Pages/Admin/Announcement/AnnouncementList'))
// const AnnouncementAdd = lazy(() => import('./Pages/Admin/Announcement/AnnouncementAdd'))
// const AdminNewsList = lazy(() => import('./Pages/Admin/News/NewsList'))
// const AdminNewsAdd = lazy(() => import('./Pages/Admin/News/NewsAdd'))
// const AdminHostelAdd = lazy(() => import('./Pages/Admin/Hostel/HostelAdd'))
// const Hostellist = lazy(() => import('./Pages/Admin/Hostel/Hostellist'))
// const AdminApplication = lazy(() => import('./Pages/Admin/Application/ApplicationList'))
// const AdminServices = lazy(() => import('./Pages/Admin/Services'))
// const ApplicationReview = lazy(() => import('./Pages/Admin/Application/ApplicationReview'))

// const EditAnnouncement = lazy(() => import('./Pages/Admin/Announcement/EditAnnouncement.jsx'))
// const NewsEdit = lazy(() => import('./Pages/Admin/News/NewsEdit.jsx'))
// const EditHostel = lazy(() => import('./Pages/Admin/Hostel/EditHostel.jsx'))
// const PageNotFound = lazy(() => import('../src/LandingPage/PageNotFound'))
// const Contract = lazy(() => import('./Pages/User/Application/Contract'))
// const AddServices = lazy(() => import('./Pages/Admin/Services/AddServices'))
// const AddOtherService = lazy(() => import('./Pages/Admin/Services/AddOtherService'))
// const EditOtherService = lazy(() => import('./Pages/Admin/Services/EditOtherService'))
// const EditServices = lazy(() => import('./Pages/Admin/Services/EditServices'))
// const CheckListMain = lazy(() => import('./Pages/Admin/Checklist/CheckListMain'))
// const AddCheckList = lazy(() => import('./Pages/Admin/Checklist/AddCheckList'))
// const EditCheckList = lazy(() => import('./Pages/Admin/Checklist/EditCheckList'))
// const ChargesMain = lazy(() => import('./Pages/Admin/Charges/ChargesMain'))
// const AddDeposits = lazy(() => import('./Pages/Admin/Charges/AddDeposits'))
// const EditDeposits = lazy(() => import('./Pages/Admin/Charges/EditDeposits'))
// const AddMainAmount = lazy(() => import('./Pages/Admin/Charges/AddMainAmount'))
// const EditMainAmount = lazy(() => import('./Pages/Admin/Charges/EditMainAmout'))
// const Queries = lazy(() => import('./Pages/Admin/Query/Queries'))
// const ViewQueries = lazy(() => import('./Pages/Admin/Query/ViewQueries'))

function App() {
  const [showChatbot, setShowChatbot] = useState(false);
  const [showLinks, setShowLinks] = useState(false)
  const dispatch = useDispatch();
  const data = useSelector((state) => state.AdminData.admin);
  const [showBottomLinks, setShowBottomLinks] = useState(true)

  const language = useSelector((state) => state.language.language);

  useEffect(() => {
    if(window.location.pathname.startsWith("/Admin") || window.location.pathname.startsWith("/dental")){
      setShowBottomLinks(false)
    }else{
      setShowBottomLinks(true)
    }
  }, [window.location])

  console.log(window.location)


  const links = [
    {
      id : 5,
      icon : Social3,
      navto : '',
      onClick: () => {
        window.open("https://www.facebook.com/SingaporeCustodianServices", "_blank");
      },
    },
    {
      id : 6,
      icon : Social3,
      navto : '',
      onClick: () => {
        window.open("https://www.facebook.com/SingaporeVingaInternationalStudentHostel/", "_blank");
      },
    },
    {
      id : 2,
      icon : Social8,
      navto : '',
      onClick: () => {
        window.open(
          "https://www.instagram.com/vinga_sg/",
          "_blank"
        );
      },
    },
    {
      id : 1,
      icon : Social10,
      onClick: () => {
        window.open("https://www.tiktok.com/@singaporedr2023?_t=8lLSmptEkuP&_r=1", "_blank");
      },
      navto : ''
    },
    {
      id : 3,
      icon : Social9,
      navto : '',
      onClick: () => {
        window.open(
          "https://www.xiaohongshu.com/user/profile/6202f9f0000000001000f392",
          "_blank"
        );
      },
    },
    // {
    //   id : 4,
    //   icon : Social4,
    //   navto : '',
    //   onClick: () => {
    //     window.open("https://line.me/ti/p/5HJmiIyCHu", "_blank");
    //   },
    // },
    
  ]

  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const handleShowLinks = () => {
    setShowLinks(true)
  }

  const handleHideLinks = () => {
    setShowLinks(false)
  }


  useEffect(() => {
    changeLanguage(language);
  }, [language]);

  useEffect(() => {
    dispatch(HostelGetAll());
    dispatch(AnnouncementGetAll());
    dispatch(ServicesGetAll());
    dispatch(OtherServicesGetAll());
  }, []);

  return (
    <>
   
    
    <div className="App">
      <ToastContainer />
      <BrowserRouter>
        <Suspense
          fallback={
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
              }}
            >
              <div className="loader"></div>
            </Box>
          }
        >
          <Routes>
            {/* User/ */}
            <Route path="/login" element={<LandingPage />} />

            <Route path="/pdfGenerate" element={<PdfGenerate />} />

            <Route path="/" element={<PublicRoute><Dashboard /></PublicRoute>}>
             
                <>
                  <Route path="/account" element={<PrivateRoute><Account /></PrivateRoute>} />
                  <Route path="/contactus" element={<ContactUs />} />
                  <Route path="/Checklist" element={<PrivateRoute><ChecklistItems /></PrivateRoute>} />
                  <Route path="/CheckoutForm" element={<PrivateRoute><CheckoutForm /></PrivateRoute>} />
                  <Route path="/Breakcontact" element={<PrivateRoute><BreakContact /></PrivateRoute>} />
                  <Route path="/hostelApplication" element={<PrivateRoute><Contract /></PrivateRoute>} />
                </>
             

              <Route index element={<Main />} />
              <Route path="/news" element={<NewsList />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/helpcenter" element={<HelpCenter />} />
              <Route path="/news/:id" element={<NewsReview />} />
              <Route path="/application" element={<Application />} />
              <Route path="/services/:id" element={<Services />} />
              <Route path="/dental-clinic" element={<DentalMainPage />} />
              <Route path="/dental-clinics" element={<DentalClinics />} />
              <Route path="/intro" element={<Intro />} />
              <Route path="/hostelreview/:id" element={<HostelReview />} />
              <Route path="/contact-us" element={<ContactUsMain />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/policyNotice" element={<PrivacyPolicy />} />
              <Route path="/payment-success" element={<PrivateRoute><PaymentSuccess /></PrivateRoute>} />


              <Route
                path="/dental-clinics/application/:id"
                element={<PrivateRoute><ApplicationDental /></PrivateRoute>}
              />

              <Route
                path="/services/landingpackage/:id"
                element={<PrivateRoute><LandingService /></PrivateRoute>}
              />
              <Route
                path="/services/academypathwaycounseling/:id"
                element={<PrivateRoute><AcademyPathwayCounselling /></PrivateRoute>}
              />
              <Route
                path="/services/charteredcarservice/:id"
                element={<PrivateRoute><ChartedCarService /></PrivateRoute>}
              />
              <Route
                path="/services/englishtrialclass/:id"
                element={<PrivateRoute><EnglishTrialClass /></PrivateRoute>}
              />
              <Route
                path="/services/festivalactivities/:id"
                element={<PrivateRoute><FestivalActivities /></PrivateRoute>}
              />
              <Route
                path="/services/guardianservice/:id"
                element={<PrivateRoute><GuardianService /></PrivateRoute>}
              />
              <Route
                path="/services/internationalcompetition/:id"
                element={<PrivateRoute><InternationalCompetition /></PrivateRoute>}
              />
              <Route
                path="/services/pickupservice/:id"
                element={<PrivateRoute><PickUpService /></PrivateRoute>}
              />
              <Route
                path="/services/subjecttuition/:id"
                element={<PrivateRoute><SubjectTuition /></PrivateRoute>}
              />
              <Route
                path="/services/weekendactivities/:id"
                element={<PrivateRoute><WeekendActivities /></PrivateRoute>}
              />
            </Route>

            <Route path="/*" element={<PageNotFound />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/dental/login" element={<DentalLogin />} />
            <Route path="/dental/forgot-password" element={<ForgotPasswordDental />} />

            <Route path="/dental" element={<DentalRoute><DentalDashboard /></DentalRoute>}>
  <Route path="profile" index element={<DentalRoute><DentalProfile /></DentalRoute>} />
  <Route path="bookings" element={<DentalRoute><DentalApplications /></DentalRoute>} />
</Route>
            
              <>
              
                <Route path="/Admin" element={<AdminRoute><AdminDashboard /></AdminRoute>}>
                  {/* <Route path="/Admin/AnnouncementList" element={<AnnouncementList />} /> */}
                  <Route index element={<AdminRoute><AnnouncementList /></AdminRoute>} />
                  <Route
                    path="/Admin/AnnouncementAdd"
                    element={<AdminRoute><AnnouncementAdd /></AdminRoute>}
                  />

                <Route
                    path="/Admin/dental-content"
                    element={<AdminRoute><DentelContent /></AdminRoute>}
                  />

                  <Route
                    path="/Admin/dental-bookings"
                    element={<AdminRoute><DentalBookings /></AdminRoute>}
                  />


                  <Route
                    path="/Admin/terms"
                    element={<AdminRoute><AdminTermsCondition /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/policyNotice"
                    element={<AdminRoute><AdminPolicyNotice /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/edit-announcement/:id"
                    element={<AdminRoute><EditAnnouncement /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/dental"
                    element={<AdminRoute><DentalMain /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/dental-add"
                    element={<AdminRoute><DentalAdd /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/dental-edit/:id"
                    element={<AdminRoute><DentalEdit /></AdminRoute>}
                  />
                  <Route path="/Admin/NewsList" element={<AdminRoute><AdminNewsList /></AdminRoute>} />
                  <Route path="/Admin/aboutUs" element={<AdminRoute><AboutMain /></AdminRoute>} />
                  <Route
                    path="/Admin/contact-us-client"
                    element={<AdminRoute><ContactUsAdmin /></AdminRoute>}
                  />
                  <Route path="/Admin/NewsAdd" element={<AdminRoute><NewsAdd /></AdminRoute>} />
                  <Route path="/Admin/edit-news/:id" element={<AdminRoute><NewsEdit /></AdminRoute>} />
                  <Route path="/Admin/HostelAdd" element={<AdminRoute><AdminHostelAdd /></AdminRoute>} />
                  <Route
                    path="/Admin/edit-hostel/:id"
                    element={<AdminRoute><EditHostel /></AdminRoute>}
                  />
                  <Route path="/Admin/Hostellist" element={<AdminRoute><Hostellist /></AdminRoute>} />
                  <Route
                    path="/Admin/Application"
                    element={<AdminRoute><AdminApplication /></AdminRoute>}
                  />
                  <Route path="/Admin/Services" element={<AdminRoute><AdminServices /></AdminRoute>} />

                  <Route path="/Admin/users" element={<AdminRoute><UserMain /></AdminRoute>} />
                  <Route path="/Admin/view-user/:id" element={<AdminRoute><ViewUser /></AdminRoute>} />
                  <Route
                    path="/Admin/view-temporary-user/:id"
                    element={<AdminRoute><ViewTemporaryUser /></AdminRoute>}
                  />

                  <Route
                    path="/Admin/common-services"
                    element={<AdminRoute><CommonServices /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/add-common-service"
                    element={<AdminRoute><AddCommonService /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/edit-common-service/:id"
                    element={<AdminRoute><EditCommonService /></AdminRoute>}
                  />

                  <Route
                    path="/Admin/booked-services"
                    element={<AdminRoute><BookedServicesMain /></AdminRoute>}
                  />

                  <Route
                    path="/Admin/view-booked-services/:id"
                    element={<AdminRoute><ViewBookedService /></AdminRoute>}
                  />

               

                  <Route path="/Admin/carousel" element={<AdminRoute><CarouselMain /></AdminRoute>} />
                  <Route path="/Admin/add-carousel" element={<AdminRoute><AddCarousel /></AdminRoute>} />
                  <Route
                    path="/Admin/edit-carousel/:id"
                    element={<AdminRoute><EditCarousel /></AdminRoute>}
                  />

                  <Route path="/Admin/checklist" element={<AdminRoute><CheckListRequest /></AdminRoute>} />

                  <Route path="/Admin/Checklist-main" element={<AdminRoute><CheckListMain /></AdminRoute>} />
                  <Route
                    path="/Admin/AddChecklist"
                    element={<AdminRoute><AddCheckList /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/edit-checklist/:id"
                    element={<AdminRoute><EditCheckList /></AdminRoute>}
                  />

                  <Route path="/Admin/Charges" element={<AdminRoute><ChargesMain /></AdminRoute>} />
                  <Route path="/Admin/add-deposit" element={<AdminRoute><AddDeposits /></AdminRoute>} />
                  <Route
                    path="/Admin/edit-deposit/:id"
                    element={<AdminRoute><EditDeposits /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/add-main-amount"
                    element={<AdminRoute><AddMainAmount /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/edit-main-amount/:id"
                    element={<AdminRoute><EditMainAmount /></AdminRoute>}
                  />

                  <Route path="/Admin/Queries" element={<AdminRoute><Queries /></AdminRoute>} />
                  <Route
                    path="/Admin/view-query/:id"
                    element={<AdminRoute><ViewQueries /></AdminRoute>}
                  />

                  <Route path="/Admin/contact-us" element={<AdminRoute><ContactList /></AdminRoute>} />
                  <Route
                    path="/Admin/view-contact/:id"
                    element={<AdminRoute><ViewContact /></AdminRoute>}
                  />

                  <Route path="/Admin/add-service" element={<AdminRoute><AddServices /></AdminRoute>} />
                  <Route
                    path="/Admin/edit-service/:id"
                    element={<AdminRoute><EditServices /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/add-other-service"
                    element={<AdminRoute><AddOtherService /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/edit-other-service/:id"
                    element={<AdminRoute><EditOtherService /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/ApplicationView/:id"
                    element={<AdminRoute><ApplicationReview /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/view-checklist-application/:id"
                    element={<AdminRoute><ViewCheckListRequest /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/student-report"
                    element={<AdminRoute><StudentReportList /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/student-report/add"
                    element={<AdminRoute><StudentReportAdd /></AdminRoute>}
                  />
                  <Route
                    path="/Admin/student-report/edit/:id"
                    element={<AdminRoute><StudentReportAdd /></AdminRoute>}
                  />
                </Route>
              </>
       
          </Routes>
        </Suspense>

        {showBottomLinks && (
          <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 9999,
          display : 'flex',
          flexDirection : 'column',
          gap : 2,
          alignItems : 'center'
        }}
      >
        {showLinks && (
          <Box className="animate-slide-up" onMouseOver={handleShowLinks}  sx={{backgroundColor : "white", py : 2, borderRadius : '10px', gap : 3.5, border : '.5px solid #1A2461', height : 'auto', width : {xs : '50px', sm : '60px'}, display : 'flex', justifyContent : 'center', alignItems : 'center', flexDirection : 'column'}}>
            {links.map((data) => (
              <Box onClick={() => data.onClick()} component={"img"} src={data.icon} sx={{width : '24px', height : '24px', ":hover" : {cursor : 'pointer'}}}></Box>
            ))}
          </Box>
        )}
        <Box
          onClick={() => setShowLinks((prev) => !prev)}
          
          sx={{
            backgroundColor : "white",
            ":hover" : {
              cursor : 'pointer',
            },
            width : {xs : '50px', sm : '60px'},
            height : {xs : '50px', sm : '60px'},
            border : '.5px solid #1A2461',
            borderRadius : '10px',
            display : 'flex',
            justifyContent : 'center',
            alignItems : 'center'
          }}
        >
         <Box component={"img"} src={Link2} sx={{width : '24px', height : '24px'}}></Box>
        </Box>

        <IconButton
          onClick={() => setShowChatbot((prev) => !prev)}
          sx={{
            backgroundColor : 'white',
            width : {xs : '50px', sm : '60px'},
            height : {xs : '50px', sm : '60px'},
            borderRadius : '10px',
            border : '.5px solid #1A2461',
            color: "#27BAC4",
            "&:hover": { bgcolor: "white" },
          }}
        >
          {showChatbot ? <CancelIcon /> : <ChatIcon />}
        </IconButton>
      </Box>
        )}
        

      {showChatbot && (
        <Box
          sx={{
            position: "fixed",
            bottom: 80,
            right: 20,
            zIndex: 9998000000,
            width: 270,
            maxHeight: "70vh",
            boxShadow: 3,
            borderRadius: 2,
            overflow: "hidden",
            backgroundColor: "#fff",
          }}
        >
          <Chatbot
            config={config}
            messageParser={MessageParser}
            actionProvider={ActionProvider}
          />
        </Box>
      )}
      </BrowserRouter>
    </div>
    </>
  );
}

export default App;
